import React from 'react';
import MultiSelectDropdown from './MultiSelectDropdown';
import { useMemberGroup } from 'contexts/MemberGroupContext';

const MemberGroupDropdown = ({ label = "Member Group", value, onChange, required = false, error = false, multiSelect = true, className = "", labelClassName = "", includeWithoutGroup = false, placeholder = null }) => {
    const { getAllMemberGroup } = useMemberGroup();

    const fetchMemberGroups = async (searchValue, page) => {
        try {
            const response = await getAllMemberGroup({ page, limit: 50, search: searchValue, activeOnly: true });

            let options = response.groups.map((group) => ({
                label: group.name,
                value: group.id,
            }));

            if (includeWithoutGroup && page === 1) {
                options.unshift({ label: "Without Group", value: "without-group" });
            }

            return {
                options,
                hasMore: response.totalPages === 0 ? false : page !== response.totalPages,
            };
        } catch (error) {
            console.error('Error fetching member groups in dropdown:', error);
            return { options: [], hasMore: false };
        }
    };

    return (
        <MultiSelectDropdown
            label={label}
            value={value}
            placeholder={placeholder}
            className={className}
            labelClassName={labelClassName}
            onChange={onChange}
            fetchData={fetchMemberGroups}
            multiSelect={multiSelect}
            required={required}
            error={error}
        />
    );
};

export default MemberGroupDropdown;
